import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _299eee86 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _03f8096c = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _345c5833 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5c8ba867 = () => interopDefault(import('../pages/pictures/index.vue' /* webpackChunkName: "pages/pictures/index" */))
const _4417d0fd = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _7ff7ae41 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _b1036326 = () => interopDefault(import('../pages/career.vue' /* webpackChunkName: "pages/career" */))
const _e80733f4 = () => interopDefault(import('../pages/magazine/index.vue' /* webpackChunkName: "pages/magazine/index" */))
const _603cfce8 = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _14a47d6e = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _fc998dec = () => interopDefault(import('../pages/editors/index.vue' /* webpackChunkName: "pages/editors/index" */))
const _bd40f054 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _e8dee414 = () => interopDefault(import('../pages/whispers-of-wood.vue' /* webpackChunkName: "pages/whispers-of-wood" */))
const _36d5dbe5 = () => interopDefault(import('../pages/checkout/successful-order.vue' /* webpackChunkName: "pages/checkout/successful-order" */))
const _5b9ea8ed = () => interopDefault(import('../pages/user/favourite-products.vue' /* webpackChunkName: "pages/user/favourite-products" */))
const _5ab8e020 = () => interopDefault(import('../pages/checkout/shipping-and-payment-details.vue' /* webpackChunkName: "pages/checkout/shipping-and-payment-details" */))
const _cdeec5ac = () => interopDefault(import('../pages/checkout/cart.vue' /* webpackChunkName: "pages/checkout/cart" */))
const _47c2eae8 = () => interopDefault(import('../pages/checkout/summary.vue' /* webpackChunkName: "pages/checkout/summary" */))
const _78393a06 = () => interopDefault(import('../pages/checkout/personal-data.vue' /* webpackChunkName: "pages/checkout/personal-data" */))
const _3dc1a6d9 = () => interopDefault(import('../pages/editors/star-map.vue' /* webpackChunkName: "pages/editors/star-map" */))
const _1f07bb7e = () => interopDefault(import('../pages/editors/topo-map.vue' /* webpackChunkName: "pages/editors/topo-map" */))
const _5a579739 = () => interopDefault(import('../pages/editors/wood-star-map.vue' /* webpackChunkName: "pages/editors/wood-star-map" */))
const _97524798 = () => interopDefault(import('../pages/editors/wood-map.vue' /* webpackChunkName: "pages/editors/wood-map" */))
const _34eceed8 = () => interopDefault(import('../pages/editors/map.vue' /* webpackChunkName: "pages/editors/map" */))
const _e7b3de1c = () => interopDefault(import('../pages/editors/city-map.vue' /* webpackChunkName: "pages/editors/city-map" */))
const _1bacb604 = () => interopDefault(import('../pages/user/forgotten-password/_id.vue' /* webpackChunkName: "pages/user/forgotten-password/_id" */))
const _1bf4ba04 = () => interopDefault(import('../pages/payment-failed/_id.vue' /* webpackChunkName: "pages/payment-failed/_id" */))
const _1341c54a = () => interopDefault(import('../pages/payment-successful/_id.vue' /* webpackChunkName: "pages/payment-successful/_id" */))
const _4bcd39b3 = () => interopDefault(import('../pages/magazine/_article.vue' /* webpackChunkName: "pages/magazine/_article" */))
const _3bf85e76 = () => interopDefault(import('../pages/order-failed/_id.vue' /* webpackChunkName: "pages/order-failed/_id" */))
const _fd1d6a74 = () => interopDefault(import('../pages/payment-feedback/_id.vue' /* webpackChunkName: "pages/payment-feedback/_id" */))
const _3f7058b8 = () => interopDefault(import('../pages/products/_category/index.vue' /* webpackChunkName: "pages/products/_category/index" */))
const _49175cd3 = () => interopDefault(import('../pages/order-successful/_id.vue' /* webpackChunkName: "pages/order-successful/_id" */))
const _1564e25e = () => interopDefault(import('../pages/products/_category/_product/index.vue' /* webpackChunkName: "pages/products/_category/_product/index" */))
const _32a5b6eb = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/adatvedelmi-nyilatkozat",
    component: _299eee86,
    name: "privacy-policy___hu___default"
  }, {
    path: "/bejelentkezes",
    component: _03f8096c,
    name: "login___hu___default"
  }, {
    path: "/en",
    component: _345c5833,
    name: "index___en"
  }, {
    path: "/falikepek",
    component: _5c8ba867,
    name: "pictures___hu___default"
  }, {
    path: "/felhasznalo",
    component: _4417d0fd,
    name: "user___hu___default"
  }, {
    path: "/hu",
    component: _345c5833,
    name: "index___hu"
  }, {
    path: "/kapcsolat",
    component: _7ff7ae41,
    name: "contact___hu___default"
  }, {
    path: "/karrier",
    component: _b1036326,
    name: "career___hu___default"
  }, {
    path: "/magazin",
    component: _e80733f4,
    name: "magazine___hu___default"
  }, {
    path: "/regisztracio",
    component: _603cfce8,
    name: "registration___hu___default"
  }, {
    path: "/rolunk",
    component: _14a47d6e,
    name: "about___hu___default"
  }, {
    path: "/szerkesztok",
    component: _fc998dec,
    name: "editors___hu___default"
  }, {
    path: "/termekek",
    component: _bd40f054,
    name: "products___hu___default"
  }, {
    path: "/whispers-of-wood",
    component: _e8dee414,
    name: "whispers-of-wood___hu___default"
  }, {
    path: "/checkout/successful-order",
    component: _36d5dbe5,
    name: "checkout-successful-order___hu___default"
  }, {
    path: "/en/about",
    component: _14a47d6e,
    name: "about___en"
  }, {
    path: "/en/career",
    component: _b1036326,
    name: "career___en"
  }, {
    path: "/en/contact",
    component: _7ff7ae41,
    name: "contact___en"
  }, {
    path: "/en/editors",
    component: _fc998dec,
    name: "editors___en"
  }, {
    path: "/en/login",
    component: _03f8096c,
    name: "login___en"
  }, {
    path: "/en/magazine",
    component: _e80733f4,
    name: "magazine___en"
  }, {
    path: "/en/pictures",
    component: _5c8ba867,
    name: "pictures___en"
  }, {
    path: "/en/privacy-policy",
    component: _299eee86,
    name: "privacy-policy___en"
  }, {
    path: "/en/products",
    component: _bd40f054,
    name: "products___en"
  }, {
    path: "/en/registration",
    component: _603cfce8,
    name: "registration___en"
  }, {
    path: "/en/user",
    component: _4417d0fd,
    name: "user___en"
  }, {
    path: "/en/whispers-of-wood",
    component: _e8dee414,
    name: "whispers-of-wood___en"
  }, {
    path: "/felhasznalo/kedvenc-termekek",
    component: _5b9ea8ed,
    name: "user-favourite-products___hu___default"
  }, {
    path: "/hu/adatvedelmi-nyilatkozat",
    component: _299eee86,
    name: "privacy-policy___hu"
  }, {
    path: "/hu/bejelentkezes",
    component: _03f8096c,
    name: "login___hu"
  }, {
    path: "/hu/falikepek",
    component: _5c8ba867,
    name: "pictures___hu"
  }, {
    path: "/hu/felhasznalo",
    component: _4417d0fd,
    name: "user___hu"
  }, {
    path: "/hu/kapcsolat",
    component: _7ff7ae41,
    name: "contact___hu"
  }, {
    path: "/hu/karrier",
    component: _b1036326,
    name: "career___hu"
  }, {
    path: "/hu/magazin",
    component: _e80733f4,
    name: "magazine___hu"
  }, {
    path: "/hu/regisztracio",
    component: _603cfce8,
    name: "registration___hu"
  }, {
    path: "/hu/rolunk",
    component: _14a47d6e,
    name: "about___hu"
  }, {
    path: "/hu/szerkesztok",
    component: _fc998dec,
    name: "editors___hu"
  }, {
    path: "/hu/termekek",
    component: _bd40f054,
    name: "products___hu"
  }, {
    path: "/hu/whispers-of-wood",
    component: _e8dee414,
    name: "whispers-of-wood___hu"
  }, {
    path: "/rendeles/fizetes-es-kiszallitas",
    component: _5ab8e020,
    name: "checkout-shipping-and-payment-details___hu___default"
  }, {
    path: "/rendeles/kosar",
    component: _cdeec5ac,
    name: "checkout-cart___hu___default"
  }, {
    path: "/rendeles/megrendeles-osszegzese",
    component: _47c2eae8,
    name: "checkout-summary___hu___default"
  }, {
    path: "/rendeles/szemelyes-adatok",
    component: _78393a06,
    name: "checkout-personal-data___hu___default"
  }, {
    path: "/szerkesztok/csillagterkep",
    component: _3dc1a6d9,
    name: "editors-star-map___hu___default"
  }, {
    path: "/szerkesztok/domborzati-terkep",
    component: _1f07bb7e,
    name: "editors-topo-map___hu___default"
  }, {
    path: "/szerkesztok/fa-csillagterkep",
    component: _5a579739,
    name: "editors-wood-star-map___hu___default"
  }, {
    path: "/szerkesztok/fa-terkep",
    component: _97524798,
    name: "editors-wood-map___hu___default"
  }, {
    path: "/szerkesztok/terkep-szerkeszto",
    component: _34eceed8,
    name: "editors-map___hu___default"
  }, {
    path: "/szerkesztok/varosi-epulet-terkep",
    component: _e7b3de1c,
    name: "editors-city-map___hu___default"
  }, {
    path: "/en/checkout/checkout",
    component: _cdeec5ac,
    name: "checkout-cart___en"
  }, {
    path: "/en/checkout/personal-data",
    component: _78393a06,
    name: "checkout-personal-data___en"
  }, {
    path: "/en/checkout/shipping-and-payment-details",
    component: _5ab8e020,
    name: "checkout-shipping-and-payment-details___en"
  }, {
    path: "/en/checkout/successful-order",
    component: _36d5dbe5,
    name: "checkout-successful-order___en"
  }, {
    path: "/en/checkout/summary",
    component: _47c2eae8,
    name: "checkout-summary___en"
  }, {
    path: "/en/editors/city-map-editor",
    component: _e7b3de1c,
    name: "editors-city-map___en"
  }, {
    path: "/en/editors/map-editor",
    component: _34eceed8,
    name: "editors-map___en"
  }, {
    path: "/en/editors/star-map-editor",
    component: _3dc1a6d9,
    name: "editors-star-map___en"
  }, {
    path: "/en/editors/topo-map-editor",
    component: _1f07bb7e,
    name: "editors-topo-map___en"
  }, {
    path: "/en/editors/wood-map-editor",
    component: _97524798,
    name: "editors-wood-map___en"
  }, {
    path: "/en/editors/wood-star-map-editor",
    component: _5a579739,
    name: "editors-wood-star-map___en"
  }, {
    path: "/en/user/favourite-products",
    component: _5b9ea8ed,
    name: "user-favourite-products___en"
  }, {
    path: "/hu/checkout/successful-order",
    component: _36d5dbe5,
    name: "checkout-successful-order___hu"
  }, {
    path: "/hu/felhasznalo/kedvenc-termekek",
    component: _5b9ea8ed,
    name: "user-favourite-products___hu"
  }, {
    path: "/hu/rendeles/fizetes-es-kiszallitas",
    component: _5ab8e020,
    name: "checkout-shipping-and-payment-details___hu"
  }, {
    path: "/hu/rendeles/kosar",
    component: _cdeec5ac,
    name: "checkout-cart___hu"
  }, {
    path: "/hu/rendeles/megrendeles-osszegzese",
    component: _47c2eae8,
    name: "checkout-summary___hu"
  }, {
    path: "/hu/rendeles/szemelyes-adatok",
    component: _78393a06,
    name: "checkout-personal-data___hu"
  }, {
    path: "/hu/szerkesztok/csillagterkep",
    component: _3dc1a6d9,
    name: "editors-star-map___hu"
  }, {
    path: "/hu/szerkesztok/domborzati-terkep",
    component: _1f07bb7e,
    name: "editors-topo-map___hu"
  }, {
    path: "/hu/szerkesztok/fa-csillagterkep",
    component: _5a579739,
    name: "editors-wood-star-map___hu"
  }, {
    path: "/hu/szerkesztok/fa-terkep",
    component: _97524798,
    name: "editors-wood-map___hu"
  }, {
    path: "/hu/szerkesztok/terkep-szerkeszto",
    component: _34eceed8,
    name: "editors-map___hu"
  }, {
    path: "/hu/szerkesztok/varosi-epulet-terkep",
    component: _e7b3de1c,
    name: "editors-city-map___hu"
  }, {
    path: "/",
    component: _345c5833,
    name: "index___hu___default"
  }, {
    path: "/en/user/forgotten-password/:id",
    component: _1bacb604,
    name: "user-forgotten-password-id___en"
  }, {
    path: "/hu/felhasznalo/elfelejtett-jelszo/:id",
    component: _1bacb604,
    name: "user-forgotten-password-id___hu"
  }, {
    path: "/en/_failed-payment/:id",
    component: _1bf4ba04,
    name: "payment-failed-id___en"
  }, {
    path: "/en/_successful-payment/:id",
    component: _1341c54a,
    name: "payment-successful-id___en"
  }, {
    path: "/en/magazine/:article",
    component: _4bcd39b3,
    name: "magazine-article___en"
  }, {
    path: "/en/order-failed/:id",
    component: _3bf85e76,
    name: "order-failed-id___en"
  }, {
    path: "/en/order-feedback/:id",
    component: _fd1d6a74,
    name: "payment-feedback-id___en"
  }, {
    path: "/en/products/:category",
    component: _3f7058b8,
    name: "products-category___en"
  }, {
    path: "/en/successful-order/:id",
    component: _49175cd3,
    name: "order-successful-id___en"
  }, {
    path: "/felhasznalo/elfelejtett-jelszo/:id",
    component: _1bacb604,
    name: "user-forgotten-password-id___hu___default"
  }, {
    path: "/hu/fizetes-visszaigazolas/:id",
    component: _fd1d6a74,
    name: "payment-feedback-id___hu"
  }, {
    path: "/hu/magazin/:article",
    component: _4bcd39b3,
    name: "magazine-article___hu"
  }, {
    path: "/hu/sikeres-fizetes/:id",
    component: _1341c54a,
    name: "payment-successful-id___hu"
  }, {
    path: "/hu/sikeres-rendeles/:id",
    component: _49175cd3,
    name: "order-successful-id___hu"
  }, {
    path: "/hu/sikertelen-fizetes/:id",
    component: _1bf4ba04,
    name: "payment-failed-id___hu"
  }, {
    path: "/hu/sikertelen-rendeles/:id",
    component: _3bf85e76,
    name: "order-failed-id___hu"
  }, {
    path: "/hu/termekek/:category",
    component: _3f7058b8,
    name: "products-category___hu"
  }, {
    path: "/en/products/:category/:product",
    component: _1564e25e,
    name: "products-category-product___en"
  }, {
    path: "/hu/termekek/:category/:product",
    component: _1564e25e,
    name: "products-category-product___hu"
  }, {
    path: "/en/:slug",
    component: _32a5b6eb,
    name: "slug___en"
  }, {
    path: "/fizetes-visszaigazolas/:id",
    component: _fd1d6a74,
    name: "payment-feedback-id___hu___default"
  }, {
    path: "/hu/:slug",
    component: _32a5b6eb,
    name: "slug___hu"
  }, {
    path: "/magazin/:article",
    component: _4bcd39b3,
    name: "magazine-article___hu___default"
  }, {
    path: "/sikeres-fizetes/:id",
    component: _1341c54a,
    name: "payment-successful-id___hu___default"
  }, {
    path: "/sikeres-rendeles/:id",
    component: _49175cd3,
    name: "order-successful-id___hu___default"
  }, {
    path: "/sikertelen-fizetes/:id",
    component: _1bf4ba04,
    name: "payment-failed-id___hu___default"
  }, {
    path: "/sikertelen-rendeles/:id",
    component: _3bf85e76,
    name: "order-failed-id___hu___default"
  }, {
    path: "/termekek/:category",
    component: _3f7058b8,
    name: "products-category___hu___default"
  }, {
    path: "/termekek/:category/:product",
    component: _1564e25e,
    name: "products-category-product___hu___default"
  }, {
    path: "/:slug",
    component: _32a5b6eb,
    name: "slug___hu___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
